import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumeroInseeService {
  numeroIbanNoValid: any = 'FR0000000000000000000000000';
  constructor() {}

  // Constante pour le calcul de la clé
  CLE_VERIF = 97;
  // Nombre de caractère du numéro INSEE
  NB_CARACTERES = 13;

  // Verifie le numéro INSEE passé en paramètre (numero + clé)
  // <param name="strNumero">Numéro INSEE</param>
  /// <param name="strCle">Clé de verification du numéro INSEE</param>
  /// <returns>True si le numéro et la clé sont cohérents, sinon false</returns>
  public Verifier(strNumero: string, strCle: string): boolean {
    let cle = '00' + this.CalculerCleINSEE(strNumero).toString();
    let value = cle.substring(cle.length - 2, 3);
    if (value == strCle) return true;
    else return false;
  }

  public VerifierINSEE(strNumero: string): boolean {
    let strCle = '';
    strNumero = this.NettoyerString(strNumero);

    try {
      // strCle = strNumero.Remove(0, NB_CARACTERES);
      // strNumero = strNumero.Remove(NB_CARACTERES);
      strCle = strNumero.slice(this.NB_CARACTERES);
      strNumero = strNumero.slice(0, this.NB_CARACTERES);
    } catch {
      // il manque des caractères
      return false;
    }

    return this.Verifier(strNumero, strCle);
  }

  //Test if a character is Letter:
  isCharacterALetter(char: any) {
    let resultat = /^[a-zA-Z]+$/.test(char); //return true if letter
    return resultat;
  }

  //Convert string characters to ASCII numbers.
  convertCharactertoASCII(char: string): any {
    let result;
    if (this.isCharacterALetter(char)) result = char.charCodeAt(0);
    return result;
  }
  //For opposite use String.fromCharCode(10) that convert numbers to equal ASCII character For example:
  //String.fromCharCode(65,66,67); // returns 'ABC'

  public VerifierIBAN(bankAccount: string): boolean {
    bankAccount = bankAccount.toUpperCase();
    //Test is Null or Empty
    if (
      bankAccount == '' ||
      bankAccount == null ||
      bankAccount == this.numeroIbanNoValid.toUpperCase()
    ) {
      return false;
    } else if (
      bankAccount &&
      bankAccount.match(/^[A-Z0-9]+$/) &&
      bankAccount.match(/^[A-Z0-9]+$/)!.length > 0
    ) {
      //si result > 0 alors correspondance avec le regex
      bankAccount = bankAccount.replace(' ', '');
      //bank = 30087466421234567890107FR76
      let bank =
        bankAccount.substring(4, bankAccount.length - 4) +
        bankAccount.substring(0, 4);
      let asciiShift: number = 55;
      let sb: string = '';
      for (let c of bank) {
        let v;
        if (this.isCharacterALetter(c)) {
          //Convert c to ASCII number
          let c_ascii = this.convertCharactertoASCII(c);
          v = c_ascii - asciiShift;
        } else v = parseInt(c.toString());
        sb += v;
      }
      //checksumString = 30087466421234567890107152776
      //checksum = 3
      let checkSumString: string = sb.toString();
      let checksum = parseInt(checkSumString.substring(0, 1));
      let retour = false;
      for (let i = 1; i < checkSumString.length; i++) {
        let v = parseInt(checkSumString.substring(i, i + 1));
        checksum *= 10;
        checksum += v;
        checksum %= 97;
        if (checksum == 1) retour = true;
      }
      return retour; //True si checksum ==1
    } else return false;
  }

  /// Calcul la clé correspondante au numéro INSEE passé en paramètre
  /// <param name="strNumero">Numero INSEE</param>
  /// <returns>Clé du numéro INSEE passé en paramètre, 0 si numéro invalide</returns>
  public CalculerCleINSEE(strNumero: string): number {
    // clé retournée
    let cle: number = 0;
    // numéro apres convertion
    let numero: number = this.NumeroEnInt(strNumero);

    if (numero != 0) {
      cle = this.CLE_VERIF - (numero % this.CLE_VERIF);
    }

    return cle;
  }

  /// Enlève les caractères ne pouvant faire partie du numéro
  /// A-Z0-9 uniquement

  /// <param name="strNumero">Numéro INSEE</param>
  /// <returns>Retourne la chaîne épurée</returns>
  public NettoyerString(strNumero: any): string {
    strNumero = '' + strNumero;
    strNumero = strNumero.toUpperCase();
    strNumero = strNumero.replace(/\s/g, ''); //Remove empty space
    //let regINSEE = /[^A-Z0-9_]/;
    //strNumero = regINSEE. Replace(strNumero, "");

    return strNumero;
  }

  /// <summary>
  /// Convertion du numéro (string) en entier
  /// </summary>
  /// <param name="strNumero">Numéro INSEE</param>
  /// <returns>Retourne le numéro INSEE sous forme d'un entier, 0 si numéro invalide</returns>
  private NumeroEnInt(strNumero: string): number {
    // le numero apres convertion
    let numero: number = 0;

    // Pour les Corses !
    // Emplacement de la lettre pour les corses
    const INDICE_LETTRE_CORSE = 6;
    // Constante pour calcul Corse 2A
    const CORSEA = 1000000;
    // Constante pour calcul Corse 2B
    const CORSEB = 2000000;

    strNumero = this.NettoyerString(strNumero);

    // le numero doit faire NB_CARACTERES sinon c'est pas
    // la peine d'aller plus loin
    if (strNumero.length != this.NB_CARACTERES) return numero;

    // convertion en entier, si la chaîne ne peut etre convertie
    // soit une erreur, soit un Corse...
    try {
      numero = parseInt(strNumero);
      // verification du 7eme caractère
      if (strNumero[INDICE_LETTRE_CORSE] == 'A') {
        // un Corse du Sud
        strNumero = strNumero.replace('A', '0');
        if (parseInt(strNumero)) {
          numero -= CORSEA;
        }
      } else if (strNumero[INDICE_LETTRE_CORSE] == 'B') {
        // Haute Corse
        strNumero = strNumero.replace('B', '0');
        if (parseInt(strNumero)) {
          numero -= CORSEB;
        }
      }
    } catch {
      return numero;
    }
    // if (!parseInt(strNumero)) {

    // }

    return numero;
  }
}
